import { Accordion, Heading } from '@zillow/constellation-10';

import FeedOverridesSwitch from './FeedOverridesSwitch';

import type { FeedOverrideSection } from '@zg-rentals/ts-rental-manager-api-client';
import type { TagPropsInterface } from '@zillow/constellation-10';

type AccordionContentContainerProps = {
  content: React.ReactNode;
  header?: React.ReactNode;
  headingLevel?: 1 | 2 | 3 | 4 | 5 | 6;
  tag?: React.ReactElement<TagPropsInterface> | null | undefined;
  id?: string | null;
  eventId?: string;
  accordionIndex: number;
  isFeed?: boolean;
  feedOverrideSection?: FeedOverrideSection;
};
/*
 * NOTE: This component is to be used with `Accordion.Root` from `@zillow/constellation-10`
 */
const AccordionContentContainer = ({
  content,
  header = '',
  headingLevel = 3,
  tag = null,
  id = null,
  eventId,
  accordionIndex,
  isFeed = false,
  feedOverrideSection,
}: AccordionContentContainerProps) => {
  return (
    <Accordion.Item
      value={accordionIndex.toString()}
      id={id ?? undefined}
      data-eventid={eventId}
      data-accordion-index={accordionIndex}
    >
      <Accordion.Header>
        <Heading level={headingLevel} textStyle="heading-xs">
          {header}
        </Heading>
        {tag}
      </Accordion.Header>
      <Accordion.Panel>
        {isFeed && feedOverrideSection && <FeedOverridesSwitch section={feedOverrideSection} />}
        {content}
      </Accordion.Panel>
    </Accordion.Item>
  );
};

export default AccordionContentContainer;
